import type { FaireProductEntity } from "../../entity_types/product";

export const p_dmth74n6wt: FaireProductEntity = {
  token: "p_dmth74n6wt",
  type: "product",
  name: "Dry Shampoo Talc-Free",
  brandToken: "b_821a595f",
  brandName: "Lovett Sundries",
  imageUrl:
    "https://cdn.faire.com/fastly/568ea31f1269429a6f63e5147b6d9e165f79221cd94e6b8a0dbeb658ca1b0ec8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d623a81c05c2adc18cd8afb1496f8d412c1aff249431bfad97e38fcb66622860.jpeg",
    "https://cdn.faire.com/fastly/e11917f1eb9d14dd83b35b51c717d2060cfa7f70bfaddc809528a17fe1432758.jpeg",
    "https://cdn.faire.com/fastly/1a97f62c79dc822346f8139388c7d290df76dc7099b68fc835a606c99bf2383f.jpeg",
    "https://cdn.faire.com/fastly/47f9483735d49c8aeaa4a043c50f5173068ac9f6634ed58b1c674851e043c301.jpeg",
    "https://cdn.faire.com/fastly/694c490a987f2a18e9b01d1bccae2829c2141337f6597f654d6c5b19ef5d6fd2.jpeg",
  ],
  priceDollars: 9,
  description:
    "Revitalize the look and health of your hair between washes with Lovett Sundries' Natural Dry Shampoo. It's chemical-free, easy to use, and super effective. So, whether you're embracing the great outdoors for a few days, navigating an on-the-go moment, or simply letting your scalp recover after a wash day, you can feel confident in your look.\n\nOne of the core ingredients in our natural dry shampoo is bentonite clay. This natural absorbent gently removes excess oil and impurities, leaving your hair feeling clean and volumized. Its unique properties also help to promote scalp health. Then, we combine the Bentonite clay with all-natural arrowroot powder to help your hair remain bouncy, voluminous, and refreshed.\n\nChoose from a calming lavender scent or unscented. Our dry shampoo is cruelty-free, handmade, and zero-waste. Furthermore, it is talc-free and doesn't use aerosol as a propellant. \n\nLarge Net Wt: 1.41oz (43g), Travel Net wt: 0.76 oz (21 g). ",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:49.089Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
